import { useIsManager } from './identity';
import useCurrentProfile from './useCurrentProfile';

const useIsLocationMandatory = () => {
  const profile = useCurrentProfile()
  // Check for requireMappingToLocation in feature.
  const hasFeature = profile?.features?.veengu_business_profile?.requireMappingToLocation // TODO check and fix if needed
  const isManger = useIsManager();
  return hasFeature || isManger
}

export default useIsLocationMandatory